import React from 'react';
import { useVideoSupport } from "../contexts/BrowserContext";
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { codec } = useVideoSupport();
  const { t } = useTranslation();

  // Wait until browser detection is complete
  if (!codec) return null;

  const videoSrc = codec === "h265"
    ? "/topvideo-h265.mp4"
    : "/topvideo-h264.mp4";

  console.log(videoSrc)
  return (
    <section className="hero-section">
      <div className="video-background">
        <video
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={videoSrc} type='video/mp4' />
        Your browser does not support the video tag.
      </video>
        <div className="gradient-overlay"></div>
      </div>

      <div className="hero-content">
        <h1 className="hero-headline">
          {t('hero.headline')}
          <span className="hero-sub-headline">{t('hero.subHeadline')}</span>
        </h1>
        <p className="hero-tagline">
          {t('hero.tagline')}
        </p>
        <a
          href="https://play1more.com/zizi-pickleball"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-book-now-hero"
        >
          {t('hero.bookNow')}
        </a>
      </div>
    </section>
  );
};

export default Hero;
